<script>
import EditButton from '@/components/table/buttons/EditButton'
import ConfirmModal from '@/components/confirm/ConfirmModal'
import StatusBadge from '@/components/elements/StatusBadge.vue'

// order-list marks core-api computes on read; they are never stored in warning(s)
const COMPUTED_MARKS = [
    'company_payment_unknown',
    'company_payment_failed',
    'refund_failed',
]

export default {
    components: {
        ConfirmModal,
        EditButton,
        StatusBadge,
    },
    props: {
        item: null,
    },
    computed: {
        warnings() {
            let warnings = this.item.warning
                ? this.item.warnings
                : this.item?.deliveryJob?.warnings
            if (typeof warnings === 'string') warnings = JSON.parse(warnings)
            return warnings || []
        },
        // The close button clears only the stored warnings; the computed company_payment_unknown (tasks#187),
        // company_payment_failed (tasks#188) and refund_failed (tasks#189) marks would come straight back,
        // so no close button while one is shown.
        closable() {
            return !COMPUTED_MARKS.some((mark) => this.warnings.includes(mark))
        },
        showWarnings() {
            let str = ''
            this.warnings?.forEach((val, index) => {
                str += `${this.$t(`delivery_warning.${val}`)}`
                if (this.warnings.length !== index + 1) str += `,\n`
            })
            return str
        },
    },
}
</script>

<template lang="pug">
    div
        //- the remove "x" shows only while the alert is hovered or focused, next to it (no reflow)
        status-badge.mb-1.dd-warning-badge(v-for="(warning, i) in warnings" :key="i" tone="critical")
            | {{ $t(`delivery_warning.${warning}`) }}
            .dd-warning-badge__remove(v-if="closable")
                edit-button(
                    :tooltip="$t('orders.delete_warning')"
                    icon='close'
                    iconsize='12'
                    xsmall=true
                    color="#C0123C"
                    @execute="$emit('execute')"
                )
</template>

<style lang="scss">
.editable-field {
    width: 100px;
}

.v-application .dd-warning-badge {
    position: relative;

    .dd-warning-badge__remove {
        position: absolute;
        top: 50%;
        left: 100%;
        display: flex;
        padding-left: 2px;
        transform: translateY(-50%);
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.12s ease;

        .v-btn.v-btn--icon.v-size--x-small {
            width: 16px;
            height: 16px;
        }
    }

    &:hover .dd-warning-badge__remove,
    &:focus-within .dd-warning-badge__remove {
        opacity: 1;
        pointer-events: auto;
    }
}
</style>
